import { Link } from "react-router-dom";
import { Download, ArrowRight, CalendarDays, Newspaper } from "lucide-react";
import { API_BASE, formatDate } from "@/lib/api";
import { PILLARS, Txt } from "./Brand";

export function DownloadButton({ pub, className = "" }) {
  return (
    <a href={`${API_BASE}/publications/${pub.slug}/download`} className={`btn-highlight ${className}`} data-testid={`download-${pub.slug}`}
      aria-label={`Download publication (PDF): ${pub.title}`}>
      <Download aria-hidden="true" className="h-4 w-4" /> Download <span className="text-sm font-normal">(PDF)</span>
    </a>
  );
}

export function PublicationCard({ pub, index = 0 }) {
  return (
    <article className={`card-irid hoverable card-top-growth flex flex-col p-6 pt-7 rise rise-${(index % 4) + 1}`} data-testid={`publication-card-${pub.slug}`}>
      <div className="mb-4 flex flex-wrap items-center gap-2">
        <span className="chip-type">{pub.document_type}</span>
        {pub.publication_year && <span className="text-sm font-semibold text-irid-slate">{pub.publication_year}</span>}
      </div>
      <h3 className="text-xl">
        <Link to={`/publications/${pub.slug}`} className="hover:text-irid-blue" data-testid={`publication-link-${pub.slug}`}><Txt>{pub.title}</Txt></Link>
      </h3>
      <p className="mt-3 line-clamp-3 text-[15px] text-irid-ink"><Txt>{pub.abstract}</Txt></p>
      <div className="mt-auto flex flex-wrap items-center justify-between gap-3 pt-6">
        <DownloadButton pub={pub} />
        <Link to={`/publications/${pub.slug}`} className="inline-flex items-center gap-1 text-sm font-semibold text-irid-blue hover:text-irid-navy">
          Details <ArrowRight aria-hidden="true" className="h-4 w-4" />
        </Link>
      </div>
    </article>
  );
}

export function ServiceCard({ s, index = 0 }) {
  const p = PILLARS[s.pillar] || PILLARS.blue;
  return (
    <article className={`card-irid hoverable card-top ${p.border} flex flex-col p-7 md:p-9 rise rise-${index + 1}`} data-testid={`service-card-${s.slug}`}>
      <span className={`mb-6 inline-flex h-14 w-14 items-center justify-center rounded-xl ${p.tint}`}>
        <p.Icon aria-hidden="true" strokeWidth={2} className={`h-7 w-7 ${p.icon}`} />
      </span>
      <h3 className="text-2xl">{s.title}</h3>
      <p className="mt-3 text-irid-ink"><Txt>{s.service_summary}</Txt></p>
      <Link to={`/services/${s.slug}`} className="mt-6 inline-flex items-center gap-2 font-semibold text-irid-blue hover:text-irid-navy" data-testid={`service-learn-more-${s.slug}`}>
        Learn more<span className="sr-only"> about {s.title}</span> <ArrowRight aria-hidden="true" className="h-4 w-4" />
      </Link>
    </article>
  );
}

export function NewsCard({ n, index = 0 }) {
  return (
    <article className={`card-irid hoverable flex flex-col overflow-hidden rise rise-${(index % 4) + 1}`} data-testid={`news-card-${n.slug}`}>
      <div className="relative flex h-40 items-center justify-center bg-horizon" aria-hidden="true">
        <Newspaper className="h-10 w-10 text-white/70" />
        <span className="absolute bottom-2 right-3 text-[11px] text-white/80">Image awaiting IRID approval</span>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <div className="mb-3 flex flex-wrap items-center gap-3 text-sm text-irid-slate">
          <span className="chip-cat">{n.category}</span>
          <span className="inline-flex items-center gap-1"><CalendarDays aria-hidden="true" className="h-4 w-4" /><time dateTime={n.date}>{formatDate(n.date)}</time></span>
        </div>
        <h3 className="text-xl"><Link to={`/news/${n.slug}`} className="hover:text-irid-blue" data-testid={`news-link-${n.slug}`}><Txt>{n.title}</Txt></Link></h3>
        <p className="mt-3 text-[15px]"><Txt>{n.excerpt}</Txt></p>
      </div>
    </article>
  );
}
